import { DOCUMENT, inject, Injectable } from '@angular/core';
import { LinkDefinition } from '../interfaces/link';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  private document = inject(DOCUMENT);

  public updateLink(link: LinkDefinition) {
    const selectorParts = [`link[rel='${link.rel}']`];
    if (link.hreflang) {
      selectorParts.push(`[hreflang='${link.hreflang}']`);
    }
    if (link.type) {
      selectorParts.push(`[type='${link.type}']`);
    }
    if (link.crossOrigin) {
      selectorParts.push(`[crossorigin]`);
    }
    if (link.rel === 'preload' || link.rel === 'preconnect') {
      selectorParts.push(`[href='${link.href}']`);
    }
    const selector = selectorParts.join('');
    const element: HTMLLinkElement = this.document.querySelector(selector) || this.document.createElement('link');

    element.setAttribute('rel', link.rel);
    element.setAttribute('href', link.href);

    if (link.hreflang) {
      element.setAttribute('hreflang', link.hreflang);
    }
    if (link.as) {
      element.setAttribute('as', link.as);
    }
    if (link.type) {
      element.setAttribute('type', link.type);
    }
    if (link.sizes) {
      element.setAttribute('sizes', link.sizes);
    }
    if (link.property) {
      element.setAttribute('property', link.property);
    }
    if (link.content) {
      element.setAttribute('content', link.content);
    }
    if (link.color) {
      element.setAttribute('color', link.color);
    }
    if (link.crossOrigin) {
      element.setAttribute('crossorigin', link.crossOrigin === true ? '' : link.crossOrigin);
    }
    if (link.id) {
      element.id = link.id;
    }
    if (link.title) {
      element.setAttribute('title', link.title);
    } else {
      element.removeAttribute('title');
    }

    const alreadyExists = this.document.querySelector(selector);
    if (alreadyExists && this.isSameLink(this.elementToLink(element), link)) {
      return;
    }

    const lastMeta = this.document.head.querySelector('link:first-of-type');
    this.document.head.insertBefore(element, lastMeta);
  }

  public removeLink(selector: string) {
    const element: HTMLLinkElement = this.document.querySelector(selector);
    if (element) {
      this.document.head.removeChild(element);
    }
  }

  public elementToLink(el: HTMLLinkElement): LinkDefinition {
    return {
      rel: el.getAttribute('rel'),
      href: el.getAttribute('href'),
      hreflang: el.getAttribute('hreflang'),
      type: el.getAttribute('type'),
      sizes: el.getAttribute('sizes'),
      property: el.getAttribute('property'),
      content: el.getAttribute('content'),
      color: el.getAttribute('color'),
      crossOrigin: el.getAttribute('crossorigin'),
      as: el.getAttribute('as'),
      title: el.getAttribute('title'),
      id: el.id,
    };
  }

  public isSameLink(linkA: LinkDefinition, linkB: LinkDefinition): boolean {
    if (linkA.rel && linkB.rel && linkA.rel !== linkB.rel) return false;
    if (linkA.hreflang && linkB.hreflang && linkA.hreflang !== linkB.hreflang) return false;
    if (linkA.type && linkB.type && linkA.type !== linkB.type) return false;
    if (linkA.sizes && linkB.sizes && linkA.sizes !== linkB.sizes) return false;
    if (linkA.id && linkB.id && linkA.id !== linkB.id) return false;
    return true;
  }
}
